var map = {
	"./NYSI_logo_black.png": 64772,
	"./badminton.png": 64857,
	"./file-icons/default.png": 46514,
	"./file-icons/dicom.png": 19865,
	"./han-bt.png": 2571,
	"./han-sisp.png": 66304,
	"./han.png": 81838,
	"./hylyght-icon.png": 44600,
	"./ido.png": 49393,
	"./ilike.png": 19979,
	"./logo-fundis.png": 63364,
	"./logo-han-big.png": 23785,
	"./logo-han-big@2x.png": 98539,
	"./logo-han-big@3x.png": 40640,
	"./logo-sport-vl-color.png": 34782,
	"./logo-sport-vl-transparent.png": 48045,
	"./logo-sport-vl-white.png": 41804,
	"./logo-sport-vlaanderen.png": 47932,
	"./logo-ugent.png": 52814,
	"./logo.png": 82806,
	"./sporta-mundi@3x.png": 86565,
	"./ugent.png": 63204
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94504;